import { connect } from 'react-redux';
import AddressBook from 'components/Address/AddressBook/AddressBook';
import { addAddress, expandAddressBook as onExpand } from 'redux/modules/address/actions';
import { getAddressBookProps } from 'redux/modules/address/selectors';

export default connect(getAddressBookProps, { onExpand, addAddress })(AddressBook);
